// React
import React from "react";
import { useTranslation } from "react-i18next";

// MUI
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// Styles
import { styles } from "./styles";

const DuplicatePHINModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="duplicate-phin-dialog"
      sx={styles.dialog}
    >
      <DialogTitle sx={styles.dialogTitle}>
        {t("duplicatePHINModal.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t("duplicatePHINModal.message")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} sx={styles.okButton}>
          {t("buttons.ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicatePHINModal;
